import { GetterTree } from 'vuex';
import { Attributes } from '@/entities/page.attributes';
import Organization from '@/entities/organization';
import { StorageItems, StorageItemSiteInfo } from '@/entities/storage.items';
import Logger from '@/utils/logger.utils';
import { Modal } from '@/entities/modal';
import PageContext from '@/entities/page..context';
import { AppState } from '@/store/mainModule/state';
import { RootState } from '@/store/root.state';
import { DEVICE } from '@/entities/device';
import { WidgetsInfo } from '@/entities/widget.info';

export const getters: GetterTree<AppState, RootState> = {
  plId(state: AppState): number {
    let plId: number = null;
    try {
      plId = state.storageItems.getSiteInfo().privateLabelInfo.id;
    } catch (e) {
      Logger.ignore(e);
    }
    return plId;
  },

  apiEndpoints(state: AppState): any {
    return state.apiEndpoints;
  },

  plName(state: AppState): string {
    let plName: string = null;
    try {
      plName = state.storageItems.getSiteInfo().privateLabelInfo.name;
    } catch (e) {
      Logger.ignore(e);
    }
    return plName;
  },

  messages(state: AppState): Map<string, string> {
    return state.messages;
  },

  widgetsInfo(state: AppState): WidgetsInfo {
    return state.widgetsInfo;
  },

  pageAttributesMap(state: AppState): Map<number, Attributes> {
    return state.pageAttributesMap;
  },

  userOrganizationList(state: AppState): Array<Organization> {
    return state.userOrganizationList;
  },

  isSingleOrg(state: AppState): boolean {
    return state.userOrganizationList && state.userOrganizationList.length === 1;
  },

  isMobileView(state: AppState): boolean {
    return state.isMobileView;
  },
  isDesktopView(state: AppState): boolean {
    return !state.isMobileView;
  },
  isTouchScreen(state: AppState): boolean {
    return state.isTouchScreen;
  },

  storageItems(state: AppState): StorageItems {
    return state.storageItems;
  },

  siteInfo(state: AppState): StorageItemSiteInfo {
    return (state.storageItems) ? state.storageItems.getSiteInfo() : null;
  },

  pageContext(state: AppState): PageContext {
    return state.pageContext;
  },

  modal(state: AppState): Modal {
    return state.modal;
  },
  languageCode(state: AppState): string {
    return state.languageCode;
  },

  device(state: AppState): DEVICE[] {
    return state.device;
  },

  loginJstate(state: AppState): string {
    return state.loginJstate;
  },

};
